module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Hank Hanegraaff, Jay Strack\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Hank Hanegraaff serves as president and chairman of the board of the North Carolina–based Christian Research Institute. He is also host of a nationally syndicated radio broadcast, which is heard daily across the United States and Canada—and around the world via the Internet at equip.org. Hank is the author of more than twenty books. ")]), _c('P', [_vm._v("Widely regarded as one of the world’s leading Christian authors and apologists, Hank is deeply committed to equipping Christians to be so familiar with truth that when counterfeits loom on the horizon, they recognize them instantaneously. Through his live call-in broadcast, Hank answers questions on the basis of careful research and sound reasoning, and interviews today’s most significant leaders and thinkers. ")]), _c('P', [_vm._v("Hank and his wife, Kathy, live in Charlotte, North Carolina, and are parents to twelve children.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/uNjjIV/images/cover.jpg?1708648519171",
      "alt": "This image is the cover for the book Covering, Student Leadership University"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Covering, Student Leadership University\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In a world where evil seems to lurk around every corner and our thoughts turn to worry about our safety and security, the armor of God is our Father's protection in the fight against evils of our temporary home. Best-selling author Hank Hanegraaff describes God's protective covering over his children by dissecting Paul's words in Ephesians 6: 10-18 commanding us to put on the armor of God and \"take our stand against the devil's schemes.\" Hanegraaff moves through the passage, phrase by phrase, defining God's armor, explaining what it means to embrace God's covering, and the practical ways God delivers us from evil.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Thomas Nelson\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0